import { createAction } from "redux-actions";
import { IError } from "models/IError";
import { errorActions as actions } from "./constants";

export const setError = createAction<IError>(actions.SET_ERROR);
export const resetError = createAction(actions.RESET_ERROR);
